module.exports = __webpack_public_path__ + "media/images/app/products/index/categories/earrings-22b8a929ce7c5c60b1d46186a30cb534.webp";